import { ExternalService } from '@/constants/external-services'
import { useGetLicensesQuery } from '@/core/services/license'
import { selectAuthUser } from '@/redux/reducers/auth.reducer'
import { useAppSelector } from '@/redux/rootReducer'
import { isStaff } from '@/utils/type-guards'
import _ from 'lodash'

export const useMedicalActsLicenseEnabled = () => {
    const authUser = useAppSelector(selectAuthUser)
    const { data: licenses } = useGetLicensesQuery({ id: authUser?.licenses }, { skip: !authUser?.licenses.length })

    const services = _.uniq(_.flatten(licenses?.map((license) => license.services)))

    return isStaff(authUser) && services.includes(ExternalService.medicalActs)
}

export const useMedicalActsAdminLicenseEnabled = () => {
    const authUser = useAppSelector(selectAuthUser)
    const { data: licenses } = useGetLicensesQuery({ id: authUser?.licenses }, { skip: !authUser?.licenses.length })

    const services = _.uniq(_.flatten(licenses?.map((license) => license.services)))

    return isStaff(authUser) && services.includes(ExternalService.medicalActsAdmin)
}
